export default __webpack_public_path__ + "static/media/662.9ff12283.png";